import React, {useState} from 'react'
import Button from "../core/components/Button";
import img from "../core/assets/img/hero.png"
import {constants} from "../core/data/constants";
const Hero = () => {

    const contactNumber = constants[0].contactNumbers[0][0];
    const [customMessage, setCustomMessage] = useState(
        "Hola! Gracias por Comunicarte con Flaco Digital\n\n" +
        "Si tienes alguna pregunta por favor házmela saber.\n\n" +
        "Para comenzar vamos a necesitar la siguiente información:\n\n" +
        "- Tu logo\n" +
        "- Tu nombre de página de Facebook\n" +
        "- Whatsapp de atención\n" +
        "- Cuentas de pago\n" 
      );



  const whatsappLink = `https://api.whatsapp.com/send/?phone=${encodeURIComponent(contactNumber)}&text=${encodeURIComponent(customMessage)}&type=phone_number&app_absent=0`;



    return (
        <div className="z-0 text-text dark:text-darktext">
            <div className="relative max-w-screen-xl mx-auto px-1 py-28 md:px-8">

                  {/* Larger Gradient background positioned in the middle */}
                  <div className="absolute inset-0 flex justify-center items-center">
                    <div className="w-full h-[500px] max-w-lg sm:max-w-xl md:max-w-2xl blur-[150px] dark:blur-[150px] bg-gradient-light dark:bg-gradient-dark" />
                </div>
                
                {/* Responsive grid: on smaller devices, it's a column, on larger devices, it's a 2-column layout */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    
                    {/* Left Column: Text content */}
                    <div className="space-y-5 text-center md:text-left z-10">
                        <h2 className="text-3xl sm:text-4xl text-balance font-extrabold md:text-5xl">
                            La Plataforma de Líneas para Sorteos de Efectivo
                        </h2>
                        <p className="max-w-3xl sm:text-2xl text-base text-balance  mx-auto md:mx-0">
                            Gestiona tus rifas de efectivo, con la confianza, seguridad y respaldo que Flaco Digital te ofrece.
                        </p>
                        <button className="px-6 py-1 sm:text-2xl text-base bg-primary dark:bg-darkprimary text-darktext dark:text-text hover:bg-primary/90 dark:hover:bg-darkprimary/90 transition-all rounded-lg">
                            <a href={whatsappLink} target="_blank">
                              Comienza Ahora
                            </a>
                        </button>
                    </div>
                    
                    {/* Right Column: Image */}
                    <div className="flex justify-center md:justify-end z-10">
                        <img
                            src={img}
                            alt="Cellphone showing raffle app"
                            className="w-64 sm:w-72 md:w-96 object-contain"
                        />
                    </div>
                </div>
                
            </div>
        </div>
    );
};

export default Hero;
